// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/case_study.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PoolImage } from "./survey_report_pb";
import { file_api_proto_v1_survey_report } from "./survey_report_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/case_study.proto.
 */
export const file_api_proto_v1_case_study: GenFile = /*@__PURE__*/
  fileDesc("Ch1hcGlfcHJvdG8vdjEvY2FzZV9zdHVkeS5wcm90bxIMYXBpX3Byb3RvLnYxIs4CCg5DYXNlU3R1ZHlJbWFnZRIKCgJpZBgBIAEoCRIwCgVwaGFzZRgCIAEoDjIhLmFwaV9wcm90by52MS5DYXNlU3R1ZHlJbWFnZVBoYXNlEhkKDGRlYWxfZmlsZV9pZBgDIAEoA0gAiAEBEiYKGWNvbG9yX3NpbXVsYXRpb25faW1hZ2VfaWQYBCABKANIAYgBARILCgNhbHQYBSABKAkSEgoKc29ydF9vcmRlchgGIAEoBRISCgpwdWJsaWNfdXJsGAcgASgJEjAKCnBvb2xfaW1hZ2UYCCABKAsyFy5hcGlfcHJvdG8udjEuUG9vbEltYWdlSAKIAQESFgoOYWx0X3N1Z2dlc3Rpb24YCSABKAlCDwoNX2RlYWxfZmlsZV9pZEIcChpfY29sb3Jfc2ltdWxhdGlvbl9pbWFnZV9pZEINCgtfcG9vbF9pbWFnZSIsChlHZXRDYXNlU3R1ZHlJbWFnZXNSZXF1ZXN0Eg8KB2RlYWxfaWQYASABKAMiSgoaR2V0Q2FzZVN0dWR5SW1hZ2VzUmVzcG9uc2USLAoGaW1hZ2VzGAEgAygLMhwuYXBpX3Byb3RvLnYxLkNhc2VTdHVkeUltYWdlIlsKGlNhdmVDYXNlU3R1ZHlJbWFnZXNSZXF1ZXN0Eg8KB2RlYWxfaWQYASABKAMSLAoGaW1hZ2VzGAIgAygLMhwuYXBpX3Byb3RvLnYxLkNhc2VTdHVkeUltYWdlIksKG1NhdmVDYXNlU3R1ZHlJbWFnZXNSZXNwb25zZRIsCgZpbWFnZXMYASADKAsyHC5hcGlfcHJvdG8udjEuQ2FzZVN0dWR5SW1hZ2UqpQEKE0Nhc2VTdHVkeUltYWdlUGhhc2USJgoiQ0FTRV9TVFVEWV9JTUFHRV9QSEFTRV9VTlNQRUNJRklFRBAAEiEKHUNBU0VfU1RVRFlfSU1BR0VfUEhBU0VfQkVGT1JFEAESIQodQ0FTRV9TVFVEWV9JTUFHRV9QSEFTRV9EVVJJTkcQAhIgChxDQVNFX1NUVURZX0lNQUdFX1BIQVNFX0FGVEVSEANCM1oxZ2l0aHViLmNvbS9oLXNjYXBlL2llc2FwdXJpL2dvL2FwaV9wcm90by92MTthcGl2MWIGcHJvdG8z", [file_api_proto_v1_survey_report]);

/**
 * 施工事例記事に紐づく写真
 *
 * @generated from message api_proto.v1.CaseStudyImage
 */
export type CaseStudyImage = Message<"api_proto.v1.CaseStudyImage"> & {
  /**
   * deal_case_study_images.id（ULID: Crockford base32、26文字。新規追加時は空文字）
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: api_proto.v1.CaseStudyImagePhase phase = 2;
   */
  phase: CaseStudyImagePhase;

  /**
   * 画像の実体はどちらか一方（survey_part_images と同じ二択保持）
   *
   * 案件ファイルID
   *
   * @generated from field: optional int64 deal_file_id = 3;
   */
  dealFileId?: bigint;

  /**
   * AIカラーシミュレーション結果画像ID
   *
   * @generated from field: optional int64 color_simulation_image_id = 4;
   */
  colorSimulationImageId?: bigint;

  /**
   * 代替テキスト（空可。空なら出力時に区分由来の定型文へフォールバック）
   *
   * @generated from field: string alt = 5;
   */
  alt: string;

  /**
   * 区分内の表示順
   *
   * @generated from field: int32 sort_order = 6;
   */
  sortOrder: number;

  /**
   * 恒久 public URL。記事コピー時の <img src> に使う。
   * presigned URL は 1 時間で失効するためコピー用途には使えない。
   *
   * @generated from field: string public_url = 7;
   */
  publicUrl: string;

  /**
   * 選択 UI 内の表示用（presigned URL を含む）。
   * public_url とは役割が違うので両方持つ:
   *   pool_image = 画面に見せるため（失効しても再取得すればよい）
   *   public_url = 外部へコピーするため（恒久でなければならない）
   *
   * @generated from field: optional api_proto.v1.PoolImage pool_image = 8;
   */
  poolImage?: PoolImage;

  /**
   * alt の初期値サジェスト。
   * 現地調査報告書で同じ写真に付いているキャプション → 区分由来の定型文 の順に決まる。
   *
   * @generated from field: string alt_suggestion = 9;
   */
  altSuggestion: string;
};

/**
 * Describes the message api_proto.v1.CaseStudyImage.
 * Use `create(CaseStudyImageSchema)` to create a new message.
 */
export const CaseStudyImageSchema: GenMessage<CaseStudyImage> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_case_study, 0);

/**
 * 施工事例記事の写真取得リクエスト
 *
 * @generated from message api_proto.v1.GetCaseStudyImagesRequest
 */
export type GetCaseStudyImagesRequest = Message<"api_proto.v1.GetCaseStudyImagesRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.GetCaseStudyImagesRequest.
 * Use `create(GetCaseStudyImagesRequestSchema)` to create a new message.
 */
export const GetCaseStudyImagesRequestSchema: GenMessage<GetCaseStudyImagesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_case_study, 1);

/**
 * 施工事例記事の写真取得レスポンス
 *
 * @generated from message api_proto.v1.GetCaseStudyImagesResponse
 */
export type GetCaseStudyImagesResponse = Message<"api_proto.v1.GetCaseStudyImagesResponse"> & {
  /**
   * phase, sort_order の昇順
   *
   * @generated from field: repeated api_proto.v1.CaseStudyImage images = 1;
   */
  images: CaseStudyImage[];
};

/**
 * Describes the message api_proto.v1.GetCaseStudyImagesResponse.
 * Use `create(GetCaseStudyImagesResponseSchema)` to create a new message.
 */
export const GetCaseStudyImagesResponseSchema: GenMessage<GetCaseStudyImagesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_case_study, 2);

/**
 * 施工事例記事の写真保存リクエスト
 *
 * 案件単位の全置換（full-replace）。渡された images が保存後の全量になる。
 * 区分ごとの差分ではないため、1 枚だけ消したい場合も残りの全量を送る。
 *
 * @generated from message api_proto.v1.SaveCaseStudyImagesRequest
 */
export type SaveCaseStudyImagesRequest = Message<"api_proto.v1.SaveCaseStudyImagesRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: repeated api_proto.v1.CaseStudyImage images = 2;
   */
  images: CaseStudyImage[];
};

/**
 * Describes the message api_proto.v1.SaveCaseStudyImagesRequest.
 * Use `create(SaveCaseStudyImagesRequestSchema)` to create a new message.
 */
export const SaveCaseStudyImagesRequestSchema: GenMessage<SaveCaseStudyImagesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_case_study, 3);

/**
 * 施工事例記事の写真保存レスポンス
 *
 * @generated from message api_proto.v1.SaveCaseStudyImagesResponse
 */
export type SaveCaseStudyImagesResponse = Message<"api_proto.v1.SaveCaseStudyImagesResponse"> & {
  /**
   * 保存後の全量（public_url 付与済み）
   *
   * @generated from field: repeated api_proto.v1.CaseStudyImage images = 1;
   */
  images: CaseStudyImage[];
};

/**
 * Describes the message api_proto.v1.SaveCaseStudyImagesResponse.
 * Use `create(SaveCaseStudyImagesResponseSchema)` to create a new message.
 */
export const SaveCaseStudyImagesResponseSchema: GenMessage<SaveCaseStudyImagesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_case_study, 4);

/**
 * 施工事例記事の写真区分
 *
 * @generated from enum api_proto.v1.CaseStudyImagePhase
 */
export enum CaseStudyImagePhase {
  /**
   * @generated from enum value: CASE_STUDY_IMAGE_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 施工前
   *
   * @generated from enum value: CASE_STUDY_IMAGE_PHASE_BEFORE = 1;
   */
  BEFORE = 1,

  /**
   * 施工中
   *
   * @generated from enum value: CASE_STUDY_IMAGE_PHASE_DURING = 2;
   */
  DURING = 2,

  /**
   * 完工後
   *
   * @generated from enum value: CASE_STUDY_IMAGE_PHASE_AFTER = 3;
   */
  AFTER = 3,
}

/**
 * Describes the enum api_proto.v1.CaseStudyImagePhase.
 */
export const CaseStudyImagePhaseSchema: GenEnum<CaseStudyImagePhase> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_case_study, 0);

